import { scales } from './scales.js';

/**
 * Collection of design tokens for element heights. These heights are computed using the base scale
 * to ensure design consistency.
 */ const heights = {
    '2xs': scales.base * 5,
    xs: scales.base * 6,
    sm: scales.base * 8,
    md: scales.base * 10,
    lg: scales.base * 12,
    xl: scales.base * 14,
    '2xl': scales.base * 16
};

export { heights };
//# sourceMappingURL=heights.js.map
